<template>
    <div>
        <div class="bar" id="barId"></div>
        <div class="freeback" v-show="freebackShow">
            <div class="freebackText">对吉林一号遥感影像套件有更多建议和期许？快告诉我们吧！ <span style="cursor: pointer;" @click="$router.push('/Feedback');">点击反馈 ></span></div>
            <div class="freebackBlue" id="freebackBlueId">
                <img src="~@/assets/newHome/反馈关闭.png" alt="" class="freebackClose" @click="freebackShow=false">
            </div>
        </div>
        <div class="navi">
            <div class="naviContent"><span @click="$router.push('/');" style="cursor: pointer;">首页</span> / 我的套件</div>
        </div>
        <div class="zhanwei" v-show="type==0" id="zhanweiId"></div>
        <div class="NoRs" v-show="type==1" id="NoRsId">
            <div class="text1">您的账户暂无可供使用的套件</div>
            <img src="~@/assets/newHome/查看价格.png" alt="" class="baseImg1">
            <div class="text2">想详细了解各版本的细则和权益？</div>
            <div class="text3"  @click="$router.push('/Price');">点击查看 ></div>
            <div class="noRsButton1" @click="jumpBasis()">试用体验版</div>
            <div class="noRsButton2" @click="jumpEnterprise1()">购买专业版套件</div>
        </div>
        <div class="basis" v-show="type!=1&&type!=0" id="basisId" style="height:600px;">
            <div class="text1">欢迎您使用吉林一号切片影像套件</div>
            <div class="text4">请您选择</div>
            <div class="white860">
                <div class="button1" @click="goviewMapSource()">立即看图</div>
                <div class="button2" @click="$router.push('/MyRSservices');">查看套件明细</div>
                <div class="button3" @click="$router.push({path: 'userCenter', query: {'type': 1}})">项目管理</div>
                <div class="button4" @click="$router.push({path: 'userCenter', query: {'type': 3}})">团队管理</div>
                <div class="text5">立即查看和使用您购买或申请套件中的卫星影像</div>
                <div class="text6-s"></div>
                <div class="text6">查看您购买或申请的套件状态和内容明细，跟踪套件订单，了解更多套件用法，或进入相应套件的管理页面</div>
                <div class="text7-s"></div>
                <div class="text7">创建项目并管理项目内的矢量</div>
                <div class="text8-s"></div>
                <div class="text8">管理您的团队，为队员分配解译任务</div>
            </div>
        </div>

      <div v-show="type!=1&&type!=0" class="toolTitleCtn">
          <div style="width: 400px;height:40px;text-align: center;font-weight: 600;color: #000000;font-size: 30px;">
            吉林一号套件智慧工具
          </div>
          <div style="width: 400px;height:20px;text-align: center;color: #ababab;font-size: 16px;">
            提供各种实用的智能工具，丰富套件应用场景
          </div>
        </div>

      <div v-show="type!=1&&type!=0" class="toolCtn2">
        <div class="toolPositionCtn">
          <div class="toolEnterCtn" style="margin-left: auto;margin-right: auto">
            <div class="t-title">
              工具一：矢量库管理
            </div>
            <div class="t-content" style="margin-top: 10px;">
              用户可创建矢量，支持绘制多类型矢量，选择行政区，
            </div>
            <div class="t-content">
              上传矢量文件。对我的矢量进行高效管理，信息自动更新实时同步。
            </div>
            <div @click="$router.push('/vectoryLibrary')" class="t-button" style="margin-top: 45px;">
              立即使用
            </div>
          </div>
        </div>
      </div>
      <div v-show="type!=1&&type!=0" class="toolCtn1">
        <div class="toolPositionCtn">
          <div class="toolEnterCtn" style="margin-left: auto;margin-right: auto">
            <div class="t-title">
              工具二：影像拆分管理
            </div>
            <div class="t-content" style="margin-top: 10px;">
              利用自定义矢量对切片影像套件进行拆分，聚焦感兴趣区域，
            </div>
            <div class="t-content">
              实现切片影像套件的个性化区域定制。
            </div>
            <div @click="goImgSparate" class="t-button" style="margin-top: 45px;">
              立即使用
            </div>
          </div>
        </div>
      </div>
      <div v-show="type!=1&&type!=0" class="toolCtn3">
        <div class="toolPositionCtn">
          <div class="toolEnterCtn" style="margin-left: auto;margin-right: auto">
            <div class="t-title">
              工具三：在线协同解译
            </div>
            <div class="t-content" style="margin-top: 10px;">
              支持多人同时在线开展遥感解译工作，用户可选择对应的角色
            </div>
            <div class="t-content">
              （创建人、标注人员、审核人员），实现三级用户快速协作完成解译工作。
            </div>
            <div @click="$router.push('/cooperateMarkEnter')" class="t-button" style="margin-top: 45px;">
              立即使用
            </div>
          </div>
        </div>
      </div>
      <div v-show="type!=1&&type!=0" class="toolCtn4" style="margin-bottom: 80px;">
        <div class="toolPositionCtn">
          <div class="toolEnterCtn" style="margin-left: auto;margin-right: auto">
            <div class="t-title">
              工具四：外业移动核查
            </div>
            <div class="t-content" style="margin-top: 10px;">
              创建人通过PC端进行任务创建，外业核查人员手持APP进行现场核查，
            </div>
            <div class="t-content">
              审核人员在PC端进行审核。PC结合APP，打通线上线下监管核查渠道。
            </div>
            <div @click="$router.push('/fieldWorkEnter')" class="t-button" style="margin-top: 45px;">
              立即使用
            </div>
          </div>
        </div>
      </div>
        <!-- <div class="news"  v-show="type!=1&&type!=0">
            <div class="newsText1">想了解切片影像套件的用处和用法？</div>
            <div class="newsText2">查看更多关于如何使用吉林一号影像切片套件的文章和帖子</div>
            <div class="newsBlock" v-if="newsShow==1">
                <div class="newsContent">
                    <div class="newsText3">星林社区</div>
                    <img src="~@/assets/newHome/新闻1.png" alt="" class="newsImg" @click="openNews(1)">
                    <div class="newsText4" @click="openNews(1)">吉林一号切片影像套件基于TMS/WMTS协议的多种加载方式</div>
                </div>
                <div class="newsContent">
                    <div class="newsText3">星林社区</div>
                    <img src="~@/assets/newHome/新闻2.png" alt="" class="newsImg" @click="openNews(2)">
                    <div class="newsText4" @click="openNews(2)">一文读懂“吉林一号切片影像套件”各场景下的使用</div>
                </div>
                <div class="newsContent">
                    <div class="newsText3">星林社区</div>
                    <img src="~@/assets/newHome/新闻3.jpg" alt="" class="newsImg" @click="openNews(3)">
                    <div class="newsText4" @click="openNews(3)">Vue3 + Openlayers + Python flask搭建WebGIS应用系统（三）：加载“吉林一号”影像套件</div>
                </div>
                <div class="newsContent">
                    <div class="newsText3">星林社区</div>
                    <img src="~@/assets/newHome/新闻4.png" alt="" class="newsImg" style="height: 30px;top: 5px;" @click="openNews(4)">
                    <div class="newsText4" @click="openNews(4)">QGIS插件分享：吉林一号切片套件浏览插件</div>
                </div>
                <div class="newsContent">
                    <div class="newsText3">星林社区</div>
                    <img src="~@/assets/newHome/新闻5.png" alt="" class="newsImg" @click="openNews(5)">
                    <div class="newsText4" @click="openNews(5)">使用flutter加载吉林一号切片影像套件</div>
                </div>
            </div>
            <div class="newsBlock" v-if="newsShow==2">
                <div class="newsContent">
                    <div class="newsText3">星林社区</div>
                    <img src="~@/assets/newHome/新闻6.jpg" alt="" class="newsImg" @click="openNews(6)">
                    <div class="newsText4" @click="openNews(6)">Vue3 + Openlayers + Python Flask搭建WebGIS应用系统（七）：分级聚合渲染海量矢量数据</div>
                </div>
                <div class="newsContent">
                    <div class="newsText3">星林社区</div>
                    <img src="~@/assets/newHome/新闻7.jpg" alt="" class="newsImg" @click="openNews(7)">
                    <div class="newsText4" @click="openNews(7)">使用arcgis runtime for android 加载吉林一号切片影像套件</div>
                </div>
            </div>
            <img src="~@/assets/newHome/新闻左箭头.png" alt="" style="position: absolute;top: 350px;left: 100px;cursor: pointer;" @click="newsTurn(1)">
            <img src="~@/assets/newHome/新闻右箭头.png" alt="" style="position: absolute;top: 350px;right: 100px;cursor: pointer;" @click="newsTurn(2)">
        </div> -->
        <img src="~@/assets/newHome/提问.png" alt="" class="problemImg" @click="getProblem=!getProblem" v-if="type==2||type==3">
        <img src="~@/assets/newHome/二维码.png" alt="" class="erweimaImg" v-if="getProblem">
        <!-- <div class="shadow" v-if="isShadow==1">
            <div class="shadowContent1">
                <img src="~@/assets/newHome/关闭.png" alt="" class="shadowClose" @click="isShadow=0">
                <div class="shadowText1">企业版用户提示</div>
                <div class="shadowText2">亲爱的用户，系统检测到您尚未创建任何项目，您需要先创建项目才能查看定制区域内的2023年影像</div>
                <div class="shadowButton1"  @click="goviewMapSource1()">先去看看，稍后创建</div>
                <div class="shadowButton2" @click="$router.push({path: 'userCenter', query: {'type': 1}})">创建项目</div>
            </div>
        </div> -->
    </div>
  </template>
  
  <script>
    import {rootUrl} from '@/globalConfig'

  export default {
    name: "MyRSservice",
    data() {
      return {
        freebackShow:true,
        type:-1,
        num:40000,
        id:"",
        dataList:[],
        dataBasis:[],
        type3Version:1,
        rsNum:1,
        version:[],
        versionName:[],
        imgVersion:[],
        getProblem:false,
        isShadow:0,
        itemStatus:"",
        itemId:"",
        newsShow:1,
        newsCount:2,
        areaName:'',
        subName:'',
      };
    },
    methods: {
        getKey() {
            return localStorage.getItem("token");
        },
        //实名权限检查与处理（遥感商城版）
        checkAndHandleAuthentication(){
          console.log("进入实名检查")
          let loginUserId=localStorage.getItem('userId');//是否已登录
          let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
          if(!loginUserId){
            this.jumpWithPermission('仅实名','/Login','/rskit/MyRSservice')
          }
          else if(authentication!='0'){
            this.jumpWithPermission('仅实名','/Authentication','/rskit/MyRSservice')
          }
          return true;
        },
        //带权限判断的跳转
        jumpWithPermission(type,path,fromUrl){
            //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
            //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
            let loginUserId=localStorage.getItem('userId');//是否已登录
            let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
            if(type=='可游客'){
                if(fromUrl){
                    window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                }
                else {
                    window.open(rootUrl+path,"_self")
                }
            }else if(type=='仅登录'){
                //已登录
                if(loginUserId){
                    if(fromUrl){
                        window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+path,"_self")
                    }
                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }else if(type=='仅实名'){
                //已登录
                if(loginUserId){
                    //已实名
                    if(authentication=='0'){
                        if(fromUrl){
                            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                        }
                        else {
                            window.open(rootUrl+path,"_self")
                        }
                    }
                    //未实名
                    else {
                        window.open(rootUrl+'/Authentication',"_self")
                    }

                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }
        },
        getHeight(){
            // let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
            // let h = windowHeight - 236
            let zhanweiId = document.getElementById("zhanweiId")
            let NoRsId = document.getElementById("NoRsId")
            let basisId = document.getElementById("basisId")
           
            zhanweiId.style.height= "1800px"
            NoRsId.style.height= "1800px"  
            basisId.style.height= "600px"
            this.toPageTop()

        },
        jumpBasis(){
        this.$router.push({path: "/Purchase",query: {'processType':1}}); 
        },
        orderList(){
            this.axios.post("/tilesapi/tiles/register/queryTileOrder",null, {
                headers: {
                Authorization: "Bearer " + this.getKey(),
                },
            }).then((res)=>{
                let data = res.data.data
                if(data.length==0){
                    this.type=1
                }else if(data.length>0){
                    for (let i = 0; i < data.length; i++) {
                        const rep = data[i];
                        if (rep.type=='1'&&rep.status=='已付款'&&rep.expireStatus!=2) {
                            this.id = rep.repositoryId  
                            return
                        }
                        if(rep.type=='4'&&rep.postStatus=='已交付'&&rep.expireStatus!=2){
                            this.id = rep.repCountyList[0].repositoryId
                            this.areaName=rep.repCountyList[0].areaName
                            this.subName=rep.repCountyList[0].subName
                            this.$store.state.repositorySort=rep.repCountyList[0].sort
                            return
                        }
                        if (rep.type=='0') {
                            console.log(rep);
                            this.id = rep.repositoryId  
                            return
                        }
                    }
                   
                }
            })  
        },
        goviewMapSource(){
            this.$router.push("/viewMapSource"); 
        },
        goImgSparate(){
            this.$router.push('/imageSegmentation')
        },
        jumpEnterprise1(){
            this.$router.push({path: "/Purchase",query: {'processType':7}}); 
        },
        openNews(i){
            if(i==1){
                window.open("https://www.jl1mall.com/forum/PostDetail?postId=202306152108000169890")
            }else if(i==2){
                window.open("https://www.jl1mall.com/forum/PostDetail?postId=202306061153000127349")
            }else if(i==3){
                window.open("https://www.jl1mall.com/forum/PostDetail?postId=202305080856000507991")
            }else if(i==4){
                window.open("https://www.jl1mall.com/forum/PostDetail?postId=202306211730000339529")
            }else if(i==5){
                window.open("https://www.jl1mall.com/forum/PostDetail?postId=202306121711000468541")
            }else if(i==6){
                window.open("https://www.jl1mall.com/forum/PostDetail?postId=202307041453000084691")
            }else if(i==7){
                window.open("https://www.jl1mall.com/forum/PostDetail?postId=202306171037000033295")
            }
        },
        newsTurn(i){
            if(i==1){
                if(this.newsShow>1){
                    this.newsShow--
                }else if(this.newsShow==1){
                    this.newsShow=this.newsCount
                }
            }else if(i==2){
                if(this.newsShow<this.newsCount){
                    this.newsShow++
                }else if(this.newsShow==this.newsCount){
                    this.newsShow=1
                }
            }
        }
    },
    mounted() {
        document.getElementById('barId').scrollIntoView({ behavior: "instant"});
    },
    created(){
    },
    computed: {
      
    },
  };
  </script>
  
  <style scoped lang="scss">
    .bar{
    position: relative;
    width: 100%;
    height: 76px;
    background-color: #fff;
}
.freeback{
    position: relative;
    width: 100%;
    height: 40px;
    background: #0066CC;
}
.freebackBlue{
    position: absolute;
    width: 1920px;
    height: 40px;
}
.freebackText{
    position: absolute;
    left:50%;
    transform:translate(-50%,0); 
    width: 800px;
    height:40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height:40px;
    text-align: center;
    z-index: 1;
}
.freebackClose{
    position: absolute;
    width: 14px;
    height: 14px;
    right: 50px;
    top: 13px;
    cursor: pointer;
}
.navi{
    position: relative;
    width: 100%;
    height: 40px;
    background: #F5F5F6;
}
.naviContent{
    position: absolute;
    width: 1920px;
    height: 40px;
    left: calc(50% - 960px);
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 40px;
    padding-left: 120px;
}
.zhanwei{
    position: relative;
    width: 100%;
    height: 800px;
    background-color: #fff;
}
.NoRs{
    position: relative;
    width: 100%;
    height: 800px;
    background-color: #fff;
}
.text1{
    position: absolute;
    top: 75px;
    left: calc(50% - 400px);
    width: 800px;
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 42px;
    text-align: center;

}
.text4{
    position: absolute;
    top: 167px;
    left: calc(50% - 40px);
    width: 80px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3A3A3A;
line-height: 22px;
text-align: center;
}
.white860{
    position: absolute;
    top: 264px;
    left: calc(50% - 430px);
    width: 860px;
    height:300px;
}
.button1{
    position: absolute;
    top: 0px;
    left: 0;
    width: 200px;
    height: 52px;
    background: linear-gradient(107deg, #54A7FF 0%, #0066CC 100%);
    border-radius: 8px;
    font-size: 16px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 52px;
text-align: center;
cursor: pointer;
}
.button2{
    position: absolute;
    top: 0;
    left: 220px;
    width: 200px;
    height: 52px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #0066CC;
    font-size: 16px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #0066CC;
line-height: 52px;
text-align: center;
cursor: pointer;
}
.button3{
    position: absolute;
    top: 0;
    left: 440px;
    width: 200px;
    height: 52px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #0066CC;
    font-size: 16px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #0066CC;
line-height: 52px;
text-align: center;
cursor: pointer;
}
.button4{
    position: absolute;
    top: 0;
    left: 660px;
    width: 200px;
    height: 52px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #0066CC;
    font-size: 16px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #0066CC;
line-height: 52px;
text-align: center;
cursor: pointer;
}
.text5{
    position: absolute;
    top: 67px;
    left: 0;
    width: 200px;
height: 213px;
border-radius: 8px;
background-image: url(~@/assets/newHome/立即看图.png);
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #FFFFFF;
line-height: 25px;
text-align: justify;
padding-top: 23px;
padding-left: 25px;
padding-right: 25px;

}
.button1:hover ~ .text5{
    box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.25);
}
.text6-s{
    position: absolute;
    top: 67px;
    left: 220px;
    width: 200px;
height: 213px;
border-radius: 8px;
background: linear-gradient(138deg, #F5F5F6 0%, #EAEAEA 100%);
font-size: 14px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #3A3A3A;
line-height: 20px;
text-align: justify;
padding-top: 23px;
padding-left: 25px;
padding-right: 25px;

}
.text6{
    position: absolute;
    top: 67px;
    left: 220px;
    width: 200px;
height: 213px;
border-radius: 8px;
background-image: url(~@/assets/newHome/查看套件明细.png);
background-repeat: no-repeat;
background-position: right bottom;
font-size: 14px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #3A3A3A;
line-height: 20px;
text-align: justify;
padding-top: 23px;
padding-left: 25px;
padding-right: 25px;

}
.text7-s{
    position: absolute;
    top: 67px;
    left: 440px;
    width: 200px;
height: 213px;
border-radius: 8px;
background: linear-gradient(138deg, #F5F5F6 0%, #EAEAEA 100%);
font-size: 14px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #3A3A3A;
line-height: 20px;
text-align: justify;
padding-top: 23px;
padding-left: 25px;
padding-right: 25px;

}
.text7{
    position: absolute;
    top: 67px;
    left: 440px;
    width: 200px;
height: 213px;
border-radius: 8px;
background-image: url(~@/assets/newHome/项目管理.png);
background-repeat: no-repeat;
background-position: right bottom;
font-size: 14px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #3A3A3A;
line-height: 20px;
text-align: justify;
padding-top: 23px;
padding-left: 25px;
padding-right: 25px;

}
.text8-s{
    position: absolute;
    top: 67px;
    left: 660px;
    width: 200px;
height: 213px;
border-radius: 8px;
background: linear-gradient(138deg, #F5F5F6 0%, #EAEAEA 100%);
font-size: 14px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #3A3A3A;
line-height: 20px;
text-align: justify;
padding-top: 23px;
padding-left: 25px;
padding-right: 25px;

}
.text8{
    position: absolute;
    top: 67px;
    left: 660px;
    width: 200px;
height: 213px;
border-radius: 8px;
background-image: url(~@/assets/newHome/团队管理.png);
background-repeat: no-repeat;
background-position: right bottom;
font-size: 14px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #3A3A3A;
line-height: 20px;
text-align: justify;
padding-top: 23px;
padding-left: 25px;
padding-right: 25px;

}
.button2:hover ~ .text6{
    box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.25);
}
.button3:hover ~ .text7{
    box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.25);
}
.button4:hover ~ .text8{
    box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.25);
}
.baseImg1{
    position: absolute;
    top: 167px;
    left: calc(50% - 13px);
    width: 26px;
    height: 26px;
}
.text2{
    position: relative;
    top: 211px;
    left: calc(50% - 150px);
    width: 300px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 22px;
    text-align: center;
}
.text3{
    position: absolute;
    top: 245px;
    left: calc(50% - 50px);
    width:100px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #1E81EB;
line-height: 22px;
text-align: center;
cursor: pointer;
}
.noRsButton1-s{
    position: absolute;
    top: 342px;
    left: calc(50% - 160px);
    width: 320px;
    height: 52px;
    background: #3A3A3A;
    border-radius: 8px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 52px;
    text-align: center;
    cursor: pointer;
}
.noRsButton1{
    position: absolute;
    top: 342px;
    left: calc(50% - 337px);
    width: 320px;
    height: 52px;
    background: #3A3A3A;
    border-radius: 8px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 52px;
    text-align: center;
    cursor: pointer;
}
.noRsButton2{
    position: absolute;
    top: 342px;
    left: calc(50% + 2px);
    width: 310px;
    height: 52px;
    background: linear-gradient(107deg, #54A7FF 0%, #1E81EB 100%);
    border-radius: 8px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 52px;
    cursor: pointer;
    text-align: center;
}
.basis{
    position: relative;
    width: 100%;
    height: 1200px;
    background-color: #fff;
}
.toolTitleCtn{
  position:relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height:70px;
  margin-bottom: 40px;
}
.toolCtn1{
  position: relative;
  width:100%;
  height:356px;
  background: url("../assets/rsTool/工具一背景.png");
  background-size:cover;
  background-repeat: no-repeat;
  padding: 1px;
}
.toolCtn2{
  position: relative;
  width:100%;
  height:356px;
  background: url("../assets/rsTool/工具二背景.png");
  background-size:cover;
  background-repeat: no-repeat;
  padding: 1px;
}
.toolCtn3{
  position: relative;
  width:100%;
  height:356px;
  background: url("../assets/rsTool/工具三背景.png");
  background-size:cover;
  background-repeat: no-repeat;
  padding: 1px;
}
.toolCtn4{
  position: relative;
  width:100%;
  height:356px;
  background: url("../assets/rsTool/工具四背景.png");
  background-size:cover;
  background-repeat: no-repeat;
  padding: 1px;
}
.toolPositionCtn{
  position: relative;
  width: 100%;
  height: 200px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 88px;
  //border: solid 1px #ffad00;
  .toolEnterCtn{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 600px;
    height: 200px;
    .t-title{
      width: 100%;
      height: 53px;
      font-size: 30px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 42px;
      text-align: center;
    }
    .t-content{
      width: 100%;
      height: 26px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      color: #FFFFFF;
      line-height: 26px;
      text-align: center;
    }
    .t-button{
      width: 123px;
      height: 40px;
      background: #0066CC;
      border-radius: 4px;
      line-height: 40px;
      text-align: center;
      color: #FFFFFF;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
.basisTitle{
    position: absolute;
    top: -9px;
    left: calc(50% - 201px);
    width: 402px;
    height: 42px;
    z-index: 1;
}
.basisText1{
    position: absolute;
    top: 0px;
    left: calc(50% - 200px);
    width: 400px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 22px;
    text-align: center;
    z-index: 2;
}
.reServiceStart{
    position: absolute;
    top: 45px;
    left: calc(50% - 163px);
    width: 326px;
height: 32px;
background: #FFFFFF;
border-radius: 8px;
border: 1px solid #979797;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #777777;
line-height: 32px;
text-align: center;
}
.basisGrey{
    position: absolute;
    top: 199px;
    left: calc(50% - 640px);
    width: 1280px;
height: 420px;
background: #F7F7F7;
border-radius: 16px;
}
.greyText1{
    position: absolute;
    top: 209px;
    left: 120px;
    width: 300px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3A3A3A;
    line-height: 20px;
}
.greyText2{
    position: absolute;
    top: 149px;
    left: 120px;
    width: 400px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
    line-height: 20px;
}
.greyText2-s{
    position: absolute;
    top: 149px;
    left: 120px;
    width: 400px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
    line-height: 20px;
    background: linear-gradient(124deg, #FF914F 0%, #FF391D 100%);
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
}
.greyText3{
    position: absolute;
    top: 299px;
    left: 759px;
    width:120px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #1E81EB;
line-height: 20px;
cursor: pointer;
}
.greyLine1{
    position: absolute;
    top: 109px;
    left: 500px;
    width: 2px;
    height: 310px;
    border-right:1px dashed #979797;
    opacity: 0.7;
}
.type3Shadow{
    position: absolute;
    width:1000px;
height: 586px;
background: #F7F7F7;
border-radius: 16px;
opacity: 0.7;
}

.greyLine2{
    position: absolute;
    top: 60px;
    right: 299px;
    width: 2px;
    height: 310px;
    border-right: 1px dashed #979797;
    opacity: 0.7;
}
.geryButton{
    position: absolute;
    top: 220px;
    right: 100px;
    width: 100px;
    height: 40px;
    border-radius: 8px;
border: 1px solid #0066CC;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
color: #0066CC;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
}
.geryButton1{
    position: absolute;
    top: 250px;
    right: 100px;
    width: 100px;
height: 40px;
background: #0066CC;
border-radius: 8px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #FFFFFF;
line-height: 40px;
cursor: pointer;
text-align: center;
}
.enterprise{
    position: relative;
    width: 100%;
    height: auto;
    background-color: #fff;
}
.textType3{
    margin-top: 75px;
    margin-left: calc(50% - 200px);
    margin-bottom: 82px;
    width: 400px;
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 42px;
    text-align: center;
}
.type3Grey{
    position: relative;
    margin-bottom: 82px;
    margin-left: calc(50% - 640px);
    width: 1280px;
height: 635px;
background: #F7F7F7;
border-radius: 16px;
}
.type3Text4{
    position: absolute;
    top: 121px;
    left: 1074px;
    width: 120px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 20px;
    background: linear-gradient(124deg, #FF914F 0%, #FF391D 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.type3Button2{
    position: absolute;
    top: 159px;
    right: 100px;
    width: 100px;
height: 40px;
background: #FF4040;
border-radius: 8px;
border: 1px solid #FF4040;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #FFFFFF;
line-height: 40px;
text-align: center;
cursor: pointer;
}
.type3GreyLine{
    position: absolute;
    top: 228px;
    right: 100px;
    width: 100px;
    height: 1px;
    border-top:1px dashed #979797;
    opacity: 0.7;
}
.type3ButtonAll{
    position: absolute;
    top: 239px;
    right: 100px;
    width: 100px;
    height: 300px;
}
.type3ButtonAll-s{
    position: absolute;
    top: 259px;
    right: 100px;
    width: 100px;
    height: 300px;
}
.type3Button1{
    position: absolute;
    top: 310px;
    right: 100px;
    width: 100px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #3a3a3a;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: #3a3a3a;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
}
.buyAgain{
    position: relative;
    margin-top: -50px;
    margin-left: calc(50% - 640px);
    width: 1280px;
    height: 586px;
    /* background-color: powderblue; */
}
.problemImg{
    position: fixed;
    top: 231px;
    right: 59px;
    z-index: 100;
    width: 58px;
    height: 58px;
    cursor: pointer;
}
.erweimaImg{
    position: fixed;
    top: 279px;
    right: 60px;
width: 164px;
height: 264px;
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.shadowContent1{
    position: fixed;
    top: calc(50% - 160px);
    left: calc(50% - 400px);
    width: 800px;
    height: 320px;
    background: #FFFFFF;
    border-radius: 12px;
}
.shadowClose{
position: absolute;
width: 40px;
height: 40px;
top: 0px;
right: -55px;
cursor: pointer;
}
.shadowText1{
    position: absolute;
    top: 50px;
    left: calc(50% - 150px);
    width: 300px;
height: 60px;
font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 25px;
line-height: 30px;
text-align: center;
}
.shadowText2{
    position: absolute;
    top: 124px;
    left: 120px;
    width: 560px;
height: 50px;
font-size: 14px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #3A3A3A;
line-height: 25px;
}
.erweima1{
    position: absolute;
    top: 140px;
    left: 175px;
    width: 200px;
height: 200px;
}
.shadowButton1{
    position: absolute;
    top:234px;
    left:261px;
    width: 169px;
height: 40px;
background: #0066CC;
border-radius: 6px;
font-size: 14px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 40px;
text-align: center;
cursor: pointer;
}
.shadowButton2{
    position: absolute;
    top: 234px;
    left: 443px;
    width: 96px;
height: 40px;
background: #FFFFFF;
border-radius: 6px;
border: 1px solid #0066CC;
font-size: 14px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #0066CC;
line-height: 40px;
text-align: center;
cursor: pointer;
}
.news{
    position: relative;
    margin-top: 0px;
    margin-bottom: 125px;
    margin-left: calc(50% - 640px);
    width: 1280px;
    height: 600px;
    background-image: url('~@/assets/newHome/星林社区背景.png');
    overflow: hidden;
}
.newsText1{
    position: absolute;
    width: 1280px;
height: 30px;
top: 75px;
left: calc(50% - 640px);
font-size: 30px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 30px;
text-align: center;
}
.newsText2{
    position: absolute;
    top: 130px;
    left: calc(50% - 640px);
    width: 1280px;
    height: 20px;
    font-size: 16px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(255,255, 255, 0.7);
    text-align: center;
}
.newsContent{
    position: relative;
    width: 1130px;
    height: 40px;
    margin-bottom: 25px;
    margin-left: 0px;
}
.newsBlock{
    position: absolute;
    top: 210px;
    left: 150px;
    width: 1130px;
    height: 300px;
    overflow: hidden;
}
.newsText3{
    position: absolute;
    top: 10px;
    right: 960px;
    width: 170px;
    height: 20px;
font-size: 14px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #CCCCCC;
line-height: 20px;
text-align: right;
}
.newsImg{
    position: absolute;
    width: 80px;
    height: 40px;
    top: 0px;
    right: 854px;
    cursor: pointer;
}
.newsText4{
    position: absolute;
    top: 10px;
    left: 297px;
    width: 763px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 20px;
    cursor: pointer;
    }
  </style>
  